var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 5.60352H3.16536C2.29091 5.60352 1.58203 6.3124 1.58203 7.18685V15.1035C1.58203 15.978 2.29091 16.6868 3.16536 16.6868H15.832C16.7065 16.6868 17.4154 15.978 17.4154 15.1035V7.18685C17.4154 6.3124 16.7065 5.60352 15.832 5.60352Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6654 16.6865V4.01986C12.6654 3.59993 12.4985 3.1972 12.2016 2.90027C11.9047 2.60334 11.502 2.43652 11.082 2.43652H7.91536C7.49544 2.43652 7.09271 2.60334 6.79578 2.90027C6.49885 3.1972 6.33203 3.59993 6.33203 4.01986V16.6865",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.8c51edf4a298e0153dea9003db6bb07c.svg";
export { ForwardRef as ReactComponent };